import type { ChangeEvent, FC } from 'react';

type CheckboxPropTypes = {
  label?: string;
  name: string;
  id?: string;
  onChange?: (value: ChangeEvent<HTMLInputElement>) => void;
  checked?: boolean;
};

const Checkbox: FC<CheckboxPropTypes> = ({ checked, name, id, label, onChange }) => {
  return (
    <div className="flex items-center gap-3 py-[5px]">
      <input
        onChange={onChange}
        checked={checked}
        name={id || name}
        id={id || name}
        type="checkbox"
        className="appearance-none flex-shrink-0 checked:bg-fonbet-checked-icon md:w-[16.5px] md:h-[16.5px] bg-center bg-no-repeat checked:border-none rounded-[1px] border-fonbet-blue-100 border-2 md:border-[3px] cursor-pointer hover:bg-fonbet-blue-100/10"
      />
      <label
        className="text-base font-normal text-fonbet-black leading-4 md:leading-[30px]"
        htmlFor={id || name}
      >
        {label}
      </label>
    </div>
  );
};

export { Checkbox };
